import noPlayers from '@library/assets/images/icons/no-players-icon.svg';
import whiteArrowLeftIcon from '@library/assets/images/icons/white-arrow-left.svg';

export const NoBoardMessage = () => {
  return (
    <div className="inline-flex h-56 w-[700px] items-center justify-start gap-12 rounded-t-md bg-zinc-800 px-12 py-8">
      <img src={noPlayers} alt="No Players" />
      <div className="inline-flex flex-col items-start justify-center gap-6">
        <div className="flex flex-col items-start justify-start gap-2">
          <div className="font-heebo text-soClean-100 w-[353px] text-base font-medium leading-normal">
            Start creating the board
          </div>
          <div className="font-heebo text-soClean-100 w-[335px] text-[13px] font-normal leading-[19px]">
            Add a player and select stat type(s) to create board or line
          </div>
        </div>
        <div className="inline-flex items-center justify-center">
          <div className="flex w-[107px] items-center justify-center gap-1 rounded-md bg-purple-600 px-3 py-1">
            <div className="flex size-4 items-center justify-center">
              <img
                alt="Left Arrow icon"
                className="w-3"
                src={whiteArrowLeftIcon}
              />
            </div>
            <div className="font-heebo text-center text-[13px] font-medium leading-[19px] text-purple-50">
              Add player
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
